import mitt, { Emitter } from 'mitt';

export type OrderFormEmitterType = Emitter<{ 'reset-form-softly': void }>;
const orderFormEmitter: OrderFormEmitterType = mitt<{ 'reset-form-softly': void }>();

export default orderFormEmitter;
